export type LwStatusTone = 'destructive' | 'info' | 'neutral' | 'success' | 'warning';

type LegacyStatusPillProps = {
  label: string;
  badgeClass: string;
  tone?: never;
  className?: never;
};

type CanonicalStatusPillProps = {
  label: string;
  tone: LwStatusTone;
  italic?: boolean;
  badgeClass?: never;
  className?: string;
};

export type LwStatusPillProps = LegacyStatusPillProps | CanonicalStatusPillProps;

/** Soft tinted status pill with an exact legacy path for existing Talent screens. */
export function LwStatusPill(props: LwStatusPillProps) {
  if ('badgeClass' in props && props.badgeClass !== undefined) {
    return (
      <span className={`badge ${props.badgeClass}`}>
        <span className="bdot" />
        {props.label}
      </span>
    );
  }

  return (
    <span
      className={`lw-status-pill lw-status-pill--${props.tone}${props.italic ? ' is-italic' : ''}${props.className ? ` ${props.className}` : ''}`}
      data-tone={props.tone}
    >
      <span className="lw-status-pill__dot" aria-hidden="true" />
      {props.label}
    </span>
  );
}
